import { ArrowLeftIcon } from '@carboncopyco/icons';
import { Button, type ButtonProps } from '@carboncopyco/ui';
import type { ComponentProps } from 'react';

export const SubmitButton = (
  props: Pick<ButtonProps, 'label' | 'disabled'>
) => (
  <Button
    label="Submit"
    submit
    {...props}
  />
);

export const BackButton = (
  props: Pick<ButtonProps, 'disabled' | 'onClick'>
) => (
  <Button
    label="Back"
    secondary
    {...props}
  />
);

export const CancelButton = (
  props: Pick<ButtonProps, 'disabled' | 'onClick'>
) => (
  <Button
    label="Cancel"
    link
    dark
    {...props}
  />
);

export const UpdateChangesButton = (props: Pick<ButtonProps, 'disabled'>) => (
  <Button
    label="Update changes"
    secondary
    submit
    {...props}
  />
);

export const BackIconButton = ({
  onClick,
}: Pick<ComponentProps<'span'>, 'onClick'>) => (
  <span
    className="cursor-pointer"
    onClick={onClick}
  >
    <ArrowLeftIcon size={20} />
  </span>
);
